import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { EquipeResponsabilidadeService } from '../services/equipe-responsabilidade.service';

@Injectable({
  providedIn: 'root',
})
export class EquipeResponsabilidadeResolver implements Resolve<boolean> {
  constructor(private service: EquipeResponsabilidadeService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
